<template>
  <b-row class="pb-2">
    <e-commerce-product-details
        :cotacoes-preco-visuais="cotacoesPrecoVisuais"
        :tipo-pedido-preco-visual="tipoPedidoPrecoVisual"
        :before-add-item="beforeAddItem"
        :tipo-pedido-id="tipoPedidoId"
        :manages-client-category="managesClientCategory"
        @update:grade="updatedGrade"
        @calcular-imposto="calcularImposto"
        @remove-item="handleRemoveItem"
        @select-item="handleSelectItem"
    />
  </b-row>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { mapGetters } from 'vuex';
import GradePedidos from '@/views/app/operacoes/pedidosVendas/tabelaGrade/gradePedidos.vue';
import GradeItem from '@/components/catalogo-produtos/GradeItem.vue';
import ECommerceProductDetails from '@/views/app/operacoes/pedidosVendas/modal/TelaNovaPedido.vue';

export default {
  name: 'InserirItemModal',
  props: {
    tipoPedidoPrecoVisual: {
      type: String,
      default: null,
    },
    cotacoesPrecoVisuais: {
      type: Object,
      default: () => ({}),
    },
    tipoPedidoId: {
      type: String,
      default: null,
    },
    beforeAddItem: {
      type: Function,
      default: null,
    },
    managesClientCategory: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ECommerceProductDetails,
    GradeItem,
    GradePedidos,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        loop: true,
        loopedSlides: 5,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 5,
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 4,
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
    };
  },
  computed: {
    getInfoItem: {
      get() {
        this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];
      },
      set(value) {
        this.$store.commit('intensPedido/SET_DETALHES_ITEM', value);
      },
    },
  },
  methods: {
    updatedGrade(value) {
      this.$emit('update:grade-item', value);
    },
    handleRemoveItem(item) {
      this.$emit('remove-item', item);
    },
    calcularImposto(value) {
      this.$emit('calcular-imposto', value);
    },
    handleSelectItem(item) {
      this.$emit('select-item', item);
    },
  },
};
</script>
<style lang="scss">
// .imagens-container {
//
// }

.imagens-item-img {
  border: 1px solid var(--primary);
  width: 50px;
  height: 50px;
}

.imagens-item-img img {
  height: 50px;
}

.imagens-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .imagens-container {
    width: 100%;
    padding-bottom: 10px;
  }

  .imagens-item {
    flex-direction: row;
  }

  // .imagens-item-img img {
    // width: 100px;
    // height: 100px;
  // }
}

/* Estilize a modal e o swiper conforme necessário */
.swiper-container {
  width: 100%;
  height: 100%;
}

.swiper-slide img {
  width: 100%;
  height: 100%;
}
</style>
